import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../img/tmis_logo.png";
import { Image, Dropdown, DropdownButton, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const CreateUserAccount = () => {
  const [selectedRole, setSelectedRole] = useState("Select Role");
  const [formData, setFormData] = useState({
    username: "",
    nric: "",
    email: "",
    password: "",
    dob: "",
    intake: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleGeneratePassword = () => {
    const randomPassword = Math.random().toString(36).slice(-8);
    setFormData((prev) => ({ ...prev, password: randomPassword }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelect = (eventKey) => {
    setSelectedRole(eventKey);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const regex = /^[A-Z][0-9]{7}[A-Z]$/;

    if (!regex.test(formData.nric)) {
      toast.error("NRIC must be in the format (eg. SxxxxxxxD)", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (selectedRole === "Select Role") {
      toast.error("Please select a role.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (!formData.intake) {
      toast.error("Please enter the intake.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    try {
      const url = `${process.env.REACT_APP_API}/createUserAccount`;
      const response = await axios.post(url, {
        ...formData,
        user_role: selectedRole,
      });

      if (response.status === 200) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
        });

        setTimeout(() => {
          navigate(-1);
        }, 3000);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        fontFamily: "Manrope-Regular",
        backgroundColor: "#f4f6f6",
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28' width='56' height='28'%3E%3Cpath fill='%23cacfd2' fill-opacity='0.4' d='M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z'%3E%3C/path%3E%3C/svg%3E\")",
        minHeight: "100vh",
      }}
    >
      <div className="text-center">
        <Image src={logo} width="300px" alt="Logo" />
      </div>

      <div className="row justify-content-center align-items-center mt-3">
        <div className="col-md-6 col-lg-5">
          <div className="card bg-light shadow-lg">
            <div className="row g-0">
              <div className="col-md-12 p-4">
                <h4 className="text-center fw-bold">REGISTER</h4>
                <form onSubmit={handleSubmit} className="mt-4">
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder="Enter your username"
                      required
                    />
                    <label htmlFor="username">Username</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="nric"
                      value={formData.nric}
                      onChange={handleChange}
                      placeholder="Enter your NRIC"
                      required
                    />
                    <label htmlFor="nric">NRIC</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your Email"
                      required
                    />
                    <label htmlFor="email">Email</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input
                      type="date"
                      className="form-control"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      placeholder="Enter your Date of Birth"
                      required
                    />
                    <label htmlFor="dob">Date of Birth</label>
                  </div>
                  <div className="mb-3">
                    <div className="form-floating d-flex align-items-center position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control flex-grow-1"
                        name="password"
                        id="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter your Password"
                        required
                      />
                      <label htmlFor="password">Password</label>

                      <button
                        type="button"
                        className="btn position-absolute top-50 translate-middle-y me-2"
                        style={{ right: "90px", zIndex: 10 }}
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </button>

                      <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={handleGeneratePassword}
                      >
                        Generate
                      </button>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control"
                          name="intake"
                          value={formData.intake}
                          onChange={handleChange}
                          placeholder="Enter Intake"
                          required
                        />
                        <label htmlFor="intake">Intake</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label>Select Role</Form.Label>
                        <DropdownButton
                          title={selectedRole}
                          onSelect={handleSelect}
                          variant="outline-secondary"
                          className="w-100"
                        >
                          <Dropdown.Item eventKey="Learner">Learner</Dropdown.Item>
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary w-100">
                    Register
                  </button>
                </form>

                <ToastContainer />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUserAccount;
